import { API_URLS } from '../config/api';

// Get the authentication token
export const getAuthToken = (): string | null => {
  return localStorage.getItem('token');
};

// Get authorization header for API requests
export const getAuthHeaders = (): HeadersInit => {
  const token = getAuthToken();
  const headers: HeadersInit = {
    'Content-Type': 'application/json',
    'Accept': 'application/json',
  };
  
  // Add Bearer token if available (required for all protected endpoints)
  if (token) {
    headers['Authorization'] = `Bearer ${token}`;
  }
  
  return headers;
};

export const isAuthenticated = (): boolean => {
  const token = localStorage.getItem('token');
  const user = localStorage.getItem('user');
  
  // Check if both token and user data exist
  return !!(token && user);
};

// Get current user from API
export const getCurrentUser = async () => {
  const token = getAuthToken();
  
  if (!token) {
    throw new Error('No authentication token found');
  }
  
  try {
    const response = await fetch(API_URLS.USER, {
      method: 'GET',
      headers: {
        'Accept': 'application/json',
        'Authorization': `Bearer ${token}`,
      },
    });
    
    if (!response.ok) {
      if (response.status === 401) {
        // Token is invalid, clear storage
        localStorage.clear();
        throw new Error('Unauthenticated');
      }
      throw new Error('Failed to fetch user');
    }
    
    const user = await response.json();
    return user;
  } catch (error) {
    console.error('Error fetching current user:', error);
    throw error;
  }
};

export const logout = async () => {
  const token = getAuthToken();
  
  // Try to call logout API to revoke token on server
  if (token) {
    try {
      const response = await fetch(API_URLS.LOGOUT, {
        method: 'POST',
        headers: {
          'Accept': 'application/json',
          'Authorization': `Bearer ${token}`,
        },
      });
    
      // Even if API call fails, we still clear local storage
      if (!response.ok) {
        console.warn('Logout API call failed, but clearing local storage');
      }
    } catch (error) {
      console.error('Error during logout API call:', error);
      // Continue with logout even if API call fails
    }
  }
  
  // Clear all stored data
  localStorage.removeItem('token');
  localStorage.removeItem('user');
  localStorage.removeItem('user_email');
  localStorage.removeItem('user_role');
  localStorage.removeItem('merchant_id');
  localStorage.removeItem('merchant_name');
  
  // Redirect to signin
  window.location.href = '/signin';
};